import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilter } from '@fortawesome/free-solid-svg-icons';
import type { IconProp } from '@fortawesome/fontawesome-svg-core';

const FilterIcon = () => {
  return <StyledFontAwesomeIcon icon={faFilter as IconProp} size="sm" />;
};

export { FilterIcon };

const StyledFontAwesomeIcon = styled(FontAwesomeIcon)`
  color: var(--primary-color);
`;
